import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 280,
      py: 6,
      px: 3,
      textAlign: 'center',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 72,
        height: 72,
        borderRadius: '50%',
        bgcolor: 'grey.100',
        color: 'text.secondary',
        mb: 2.5,
        opacity: 0.8,
      }}
    >
      {icon}
    </Box>
    <Typography variant="h6" fontWeight={600} gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360, mb: action ? 3 : 0 }}>
        {description}
      </Typography>
    )}
    {action && <Stack spacing={1}>{action}</Stack>}
  </Box>
);

export default EmptyState;
